import React from 'react';
import { Text } from '@fluentui/react-components';
import { useFiscalEndReviewPageStyles } from '../styles/FiscalEndReviewPage.styles';
import {
  LAST_UPDATED_EMPTY_LABEL,
  formatLastUpdatedLabel,
} from '../utils/lastUpdated';

const LOADING_PLACEHOLDER = '-';

export interface LastUpdatedLabelProps {
  /**
   * Most-recent applied timestamp for the surface. `null`/`undefined` renders the canonical "No updates made yet" copy.
   */
  at?: string | Date | null;
  loading?: boolean;
}

export const LastUpdatedLabel: React.FC<LastUpdatedLabelProps> = ({
  at,
  loading = false,
}) => {
  const styles = useFiscalEndReviewPageStyles();

  const visibleValue = loading
    ? LOADING_PLACEHOLDER
    : formatLastUpdatedLabel(at ?? null);

  const accessibleValue = loading
    ? 'Loading…'
    : at
      ? formatLastUpdatedLabel(at)
      : LAST_UPDATED_EMPTY_LABEL;

  return (
    <Text
      size={200}
      className={styles.mutedText}
      role="status"
      aria-live="polite"
      aria-atomic="true"
      title={`Last updated: ${accessibleValue}`}
      aria-label={`Last updated: ${accessibleValue}`}
    >
      Last updated: {visibleValue}
    </Text>
  );
};
